import {Injectable, OnInit} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, ActivatedRoute} from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from './auth.service';
import {map} from 'rxjs/internal/operators';
import {BackendApiService} from '../services/backend-api.service';

@Injectable()
export class AuthGuard implements CanActivate{


  constructor(private _authService: AuthService,
              private _router: Router,
              private route:ActivatedRoute,
              private backendApiService: BackendApiService
              ) {

  }


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let reqObj = {
      token : localStorage.getItem('accessToken')
    }
    console.log(reqObj);
    this.backendApiService.checkAuthToken(reqObj).subscribe(response => {
      if(response['status'] == true){
        return true;
      }else{
        this._router.navigate(['/unauth']);
      }
      return false
    })
    // navigate to login page
    // you can save redirect url so after authing we can move them back to the page they requested
    return true;
  }

}
